var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv ng-if=\"!mpp.is_special_customer\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cnav class=\"breadcrumbs\"\u003E\u003Cspan ng-click=\"mppDetail.backLink()\"\u003E\u003Ci class=\"font-icon icon-arrow-left\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003Ezurück\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Ca ui-sref=\"inApp.mpp.side.products.landing.maincat({main: mppDetail.product.main})\" ng-click=\"mppBar.selectedProducer = ''\"\u003E{{mppDetail.product.main}}\u003C\u002Fa\u003E\u003Ca ui-sref=\"inApp.mpp.side.products.landing.maincat.subcat({main: mppDetail.product.main, sub: mppDetail.product.sub})\" ng-click=\"mppBar.selectedProducer = ''\"\u003E{{mppDetail.product.sub}}\u003C\u002Fa\u003E\u003Ca ng-click=\"mppBar.selectedProducer = mppDetail.product.Hersteller; mppBar.search()\"\u003E{{ mppDetail.product.Hersteller }}\u003C\u002Fa\u003E\u003Ca href=\"{{mppDetail.product.Artikelurl}}#item-box-description\" target=\"_blank\"\u003E{{mppDetail.product.Artikelnummer}}\u003C\u002Fa\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"row wizardbox\"\u003E\u003Cdiv class=\"header show\"\u003E\u003Cdiv class=\"title\"\u003E{{ mppDetail.product.Artikelname }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"columns small-12 large-6\"\u003E\u003Cbr\u003E\u003Cimg class=\"orbit-image\" src=\"{{ mppDetail.product.Bildurl }}\"\u003E\u003Cp class=\"hide-for-small\" ng-bind-html=\"mppDetail.product.Beschreibung\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns show-for-large-up large-1\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12 large-4\"\u003E\u003Cbr\u003E\u003Ca href=\"{{mppDetail.product.Artikelurl}}#item-box-description\" target=\"_blank\"\u003EArtikelnummer: {{ mppDetail.product.Artikelnummer }}\u003C\u002Fa\u003E\u003Cbr\u003E\u003Cspan class=\"small\"\u003EVerfügbarkeit gemäß Cyberport:\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan class=\"small\"\u003E{{mppDetail.product.Liefertermin}}\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cspan\u003EHerstellernummer: {{ mppDetail.product.HBNR }}\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan class=\"small\"\u003EEAN: {{ mppDetail.product.EAN }}\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E{{ mppDetail.product['Calculated_Preis'] | currency }} (exkl. MwSt.)\u003Cbr\u003E{{ mppDetail.product['Preis_Brutto'] | currency }} (inkl. 19 % MwSt.)\u003Cbr\u003E\u003Cbr\u003E{{ mppDetail.leasingPrice_Netto | currency }} mtl. (exkl. MwSt.)\u003Cbr\u003E{{ mppDetail.leasingPrice | currency }} mtl. (inkl. 19 % MwSt.)\u003Cbr\u003E\u003Cdiv ng-if=\"mpp.canShop &amp;&amp; !mppDetail.hasNoSupply\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"key": "mppDetail.currentQuantity","title": "gewünschte Menge","type": "number","required": pug.escape(true),"validationMessages": {"required":"Die Menge muss größer 0 sein."}}
});
},
attributes: {"class": "form-padding","name": "cartForm","id": "cartForm"}
});
pug_html = pug_html + "\u003Cbutton class=\"button primary\" ng-click=\"mpp.setArticleOnCart(mppDetail.product, mppDetail.currentQuantity)\" data-cy=\"mpp.preCheckout.common.itemDetails.buttonAddItem\"\u003EZum Warenkorb hinzufügen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"strong red\" ng-if=\"mppDetail.hasLimitedSupply\"\u003EDer gemeldete Lagerbestand ist aktuell knapp. Möglicherweise ist eine finale Verfügbarkeit nicht garantiert.\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"mppDetail.hasNoSupply &amp;&amp; mppDetail.product.Verfuegbarkeit=='1' \"\u003E\u003Cbr\u003E\u003Cp class=\"red\"\u003EDer Lagerbestand des Artikels lässt einen Abruf über das PC-Leasing aktuell nicht zu.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"mppDetail.hasNoSupply &amp;&amp; !mppDetail.product.Verfuegbarkeit =='1' \"\u003E\u003Cbr\u003E\u003Cp class=\"red\"\u003EDer Lieferterminstatus des Artikels lässt einen Abruf über das PC-Leasing aktuell nicht zu. Beachten Sie hierzu bitte auch die Verfügbarkeitsinformation von Cyberport:{{mppDetail.product.Liefertermin}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"show-for-small-only\" ng-bind-html=\"mppDetail.product.Beschreibung\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12\" ng-if=\"true\"\u003E\u003Cbr\u003E\u003Cstrong\u003EFür ausführliche Artikelbeschreibungen und Informationen gehen Sie bitte direkt auf die Website von Cyberport. Den Direktlink finden Sie oben auf der Artikelnummer - einfach klicken und Sie gelangen direkt auf die richtige Seite.\u003C\u002Fstrong\u003E\u003Cp\u003Eim PC-Leasing Shop können Sie nur Artikel abrufen, die sofort verfügbar und Cyberport davon mindestens 5 Stück gelagert hat. Hintergrund ist die Verzögerung zwischen einer Bestellung und der Auftragsannahme.\u003C\u002Fp\u003EWir arbeiten regelmäßig an der Optimierung der Abläufe.\u003Cdiv ng-if=\"mppDetail.iAmSpecialAdvisor\"\u003E\u003Cpre ng-if=\"mppDetail.isDropShip\"\u003EArtikel kommt per DropShip\u003C\u002Fpre\u003E\u003Cpre ng-if=\"!mppDetail.isDropShip\"\u003E{{ mppDetail.product.Verfuegbarkeit}} Stück im Lager\u003C\u002Fpre\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12\" ng-if=\"false\"\u003E\u003Cdiv class=\"bigbox\"\u003E\u003Cdiv class=\"header\" ng-click=\"mppDetail.beschreibungClosed = !mppDetail.beschreibungClosed\"\u003E\u003Cspan\u003EAusführliche Details\u003C\u002Fspan\u003E\u003Cspan class=\"openable\" ng-class=\"{selected: !mppDetail.beschreibungClosed}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-hide=\"mppDetail.beschreibungClosed\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Ca href=\"{{mppDetail.product.Artikelurl}}#item-box-description\" target=\"_blank\"\u003EDetails auf Cyberport ansehen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!--.bigbox.header(ng-click=\"mppDetail.datenblattClosed = !mppDetail.datenblattClosed\")\n    span Datenblatt\n    span.openable(ng-class=\"{selected: !mppDetail.datenblattClosed}\")\n.main(ng-hide=\"mppDetail.datenblattClosed\")\n    .row\n        .columns.small-12(ng-bind-html=\"mppDetail.product.Beschreibung\")\n--\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"mpp.is_special_customer\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cnav class=\"breadcrumbs\"\u003E\u003Cspan ng-click=\"mppDetail.backLink()\"\u003E\u003Ci class=\"font-icon icon-arrow-left\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003Ezurück\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Ca ui-sref=\"inApp.mpp.side.products.landing.maincat({main: mppDetail.product.main})\" ng-click=\"mppBar.selectedProducer = ''\"\u003E{{mppDetail.product.main}}\u003C\u002Fa\u003E\u003Ca ui-sref=\"inApp.mpp.side.products.landing.maincat.subcat({main: mppDetail.product.main, sub: mppDetail.product.sub})\" ng-click=\"mppBar.selectedProducer = ''\"\u003E{{mppDetail.product.sub}}\u003C\u002Fa\u003E\u003Ca ng-click=\"mppBar.selectedProducer = mppDetail.product.Hersteller; mppBar.search()\"\u003E{{ mppDetail.product.Hersteller }}\u003C\u002Fa\u003E\u003Ca href=\"{{mppDetail.product.Artikelurl}}#item-box-description\" target=\"_blank\"\u003E{{mppDetail.product.Artikelnummer}}\u003C\u002Fa\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"row wizardbox\"\u003E\u003Cdiv class=\"header show\"\u003E\u003Cdiv class=\"title\"\u003E{{ mppDetail.product.Artikelname }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"columns small-12 large-6\"\u003E\u003Cbr\u003E\u003Cimg class=\"orbit-image\" src=\"{{ mppDetail.product.Bildurl }}\"\u003E\u003Cp class=\"hide-for-small\" ng-bind-html=\"mppDetail.product.Beschreibung\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns show-for-large-up large-1\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12 large-4\"\u003E\u003Cbr\u003E\u003Ca href=\"{{mppDetail.product.Artikelurl}}#item-box-description\" target=\"_blank\"\u003EArtikelnummer: {{ mppDetail.product.Artikelnummer }}\u003C\u002Fa\u003E\u003Cbr\u003E\u003Cspan class=\"small\"\u003EVerfügbarkeit gemäß Cyberport:\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan class=\"small\"\u003E{{mppDetail.product.Liefertermin}}\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cspan\u003EHerstellernummer: {{ mppDetail.product.HBNR }}\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cspan class=\"small\"\u003EEAN: {{ mppDetail.product.EAN }}\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E{{ mppDetail.product['Preis_Brutto'] | currency }} (inkl. 19 % MwSt.)\u003Cbr\u003E{{ mppDetail.leasingPrice | currency }} Budgetbedarf\u003Cbr\u003E\u003Cdiv ng-if=\"mpp.canShop &amp;&amp; !mppDetail.hasNoSupply\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"key": "mppDetail.currentQuantity","title": "gewünschte Menge","type": "number","required": pug.escape(true),"validationMessages": {"required":"Die Menge muss größer 0 sein."}}
});
},
attributes: {"class": "form-padding","name": "cartForm","id": "cartForm"}
});
pug_html = pug_html + "\u003Cbutton class=\"button primary\" ng-click=\"mpp.setArticleOnCart(mppDetail.product, mppDetail.currentQuantity)\" data-cy=\"mpp.preCheckout.common.itemDetails.buttonAddItem\"\u003EZum Warenkorb hinzufügen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"strong red\" ng-if=\"mppDetail.hasLimitedSupply\"\u003EDer gemeldete Lagerbestand ist aktuell knapp. Möglicherweise ist eine finale Verfügbarkeit nicht garantiert.\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"mppDetail.hasNoSupply &amp;&amp; mppDetail.product.Verfuegbarkeit=='1' \"\u003E\u003Cbr\u003E\u003Cp class=\"red\"\u003EDer Lagerbestand des Artikels lässt einen Abruf über das PC-Leasing aktuell nicht zu.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"mppDetail.hasNoSupply &amp;&amp; !mppDetail.product.Verfuegbarkeit =='1' \"\u003E\u003Cbr\u003E\u003Cp class=\"red\"\u003EDer Lieferterminstatus des Artikels lässt einen Abruf über das PC-Leasing aktuell nicht zu. Beachten Sie hierzu bitte auch die Verfügbarkeitsinformation von Cyberport:{{mppDetail.product.Liefertermin}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"show-for-small-only\" ng-bind-html=\"mppDetail.product.Beschreibung\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12\" ng-if=\"true\"\u003E\u003Cbr\u003E\u003Cstrong\u003EFür ausführliche Artikelbeschreibungen und Informationen gehen Sie bitte direkt auf die Website von Cyberport. Den Direktlink finden Sie oben auf der Artikelnummer - einfach klicken und Sie gelangen direkt auf die richtige Seite.\u003C\u002Fstrong\u003E\u003Cp\u003Eim PC-Leasing Shop können Sie nur Artikel abrufen, die sofort verfügbar und Cyberport davon mindestens 5 Stück gelagert hat. Hintergrund ist die Verzögerung zwischen einer Bestellung und der Auftragsannahme.\u003C\u002Fp\u003EWir arbeiten regelmäßig an der Optimierung der Abläufe.\u003Cdiv ng-if=\"mppDetail.iAmSpecialAdvisor\"\u003E\u003Cpre ng-if=\"mppDetail.isDropShip\"\u003EArtikel kommt per DropShip\u003C\u002Fpre\u003E\u003Cpre ng-if=\"!mppDetail.isDropShip\"\u003E{{ mppDetail.product.Verfuegbarkeit}} Stück im Lager\u003C\u002Fpre\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-12\" ng-if=\"false\"\u003E\u003Cdiv class=\"bigbox\"\u003E\u003Cdiv class=\"header\" ng-click=\"mppDetail.beschreibungClosed = !mppDetail.beschreibungClosed\"\u003E\u003Cspan\u003EAusführliche Details\u003C\u002Fspan\u003E\u003Cspan class=\"openable\" ng-class=\"{selected: !mppDetail.beschreibungClosed}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-hide=\"mppDetail.beschreibungClosed\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Ca href=\"{{mppDetail.product.Artikelurl}}#item-box-description\" target=\"_blank\"\u003EDetails auf Cyberport ansehen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!--.bigbox.header(ng-click=\"mppDetail.datenblattClosed = !mppDetail.datenblattClosed\")\n    span Datenblatt\n    span.openable(ng-class=\"{selected: !mppDetail.datenblattClosed}\")\n.main(ng-hide=\"mppDetail.datenblattClosed\")\n    .row\n        .columns.small-12(ng-bind-html=\"mppDetail.product.Beschreibung\")--\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;